<div class="bg-white" [ngClass]="srvRpDesign.getResponsiveClass('p-4', 'p-3')">

  <div class="font-dialog-confirm-title d-flex justify-content-center" [ngStyle]="UIUtilityService.getHeaderStyle()">
    <span>{{ 'APP_AUTHENTICATOR.APPROVAL_TITLE' | translate : { authTitle: data.authTitle } }}</span>
  </div>

  <div class="font-dialog-confirm-content mt-3" mat-dialog-content [ngClass]="{'px-0 pb-0' : (srvRpDesign.isMobile$ | async)}">
    <p class="mb-1">
      <span class="approval-label">{{ 'APP_AUTHENTICATOR.APPROVAL_DEVICE' | translate }}:</span>
      {{ deviceName }}
    </p>
    <p class="mb-1">
      <span class="approval-label">{{ 'APP_AUTHENTICATOR.APPROVAL_LOCATION' | translate }}:</span>
      {{ data.location }}
    </p>
    <p class="mb-1">
      <span class="approval-label">{{ 'APP_AUTHENTICATOR.APPROVAL_TIMESTAMP' | translate }}:</span>
      {{ formattedTimestamp }}
    </p>
    @if (data.orderType) {
      <p class="mb-1">
        <span class="approval-label">{{ 'APP_AUTHENTICATOR.APPROVAL_ORDER_TYPE' | translate }}:</span>
        {{ data.orderType }}
      </p>
    }
    @if (data.targetName) {
      <p class="mb-1">
        <span class="approval-label">{{ targetNameLabelKey | translate }}:</span>
        {{ data.targetName }}
      </p>
    }
    @if (data.amount) {
      <p class="mb-1">
        <span class="approval-label">{{ 'APP_AUTHENTICATOR.APPROVAL_AMOUNT' | translate }}:</span>
        {{ data.amount }}
      </p>
    }
    @if (data.cardNumber) {
      <p class="mb-1">
        <span class="approval-label">{{ 'APP_AUTHENTICATOR.APPROVAL_CARD_NUMBER' | translate }}:</span>
        {{ data.cardNumber }}
      </p>
    }
    @if (data.vizAliasType) {
      <p class="mb-1">
        <span class="approval-label">{{ 'APP_AUTHENTICATOR.APPROVAL_VIZ_ALIAS_TYPE' | translate }}:</span>
        {{ vizAliasTypeDisplay }}
      </p>
    }
    @if (data.vizAliasValue) {
      <p class="mb-1">
        <span class="approval-label">{{ 'APP_AUTHENTICATOR.APPROVAL_VIZ_ALIAS_VALUE' | translate }}:</span>
        {{ data.vizAliasValue }}
      </p>
    }
    @if (data.currentStatus) {
      <p class="mb-1">
        <span class="approval-label">{{ 'APP_AUTHENTICATOR.APPROVAL_CURRENT_STATUS' | translate }}:</span>
        {{ currentStatusDisplay }}
      </p>
    }
    @if (data.newStatus) {
      <p class="mb-3">
        <span class="approval-label">{{ 'APP_AUTHENTICATOR.APPROVAL_NEW_STATUS' | translate }}:</span>
        {{ newStatusDisplay }}
      </p>
    }
    @if (isMapEnabled && center) {
      <div class="approval-map mb-3">
        <google-map
          height="180px"
          width="100%"
          [center]="center"
          [zoom]="14"
          [options]="mapOptions">
          <map-marker [position]="center"></map-marker>
        </google-map>
      </div>
    }
  </div>

  <div class="my-1 p-0 d-flex justify-content-center gap-2" mat-dialog-actions [ngClass]="srvRpDesign.getDialogButtonsPadClass()">
    <button class="py-4 font-button button-action-cancel" mat-button (click)="onReject()">
      {{ 'APP_AUTHENTICATOR.APPROVAL_NO' | translate }}
    </button>
    <button class="py-4 font-button button-action-base" mat-button (click)="onConfirm()" cdkFocusInitial>
      {{ 'APP_AUTHENTICATOR.APPROVAL_YES' | translate }}
    </button>
  </div>

  <div class="db-ip-attribution text-center mt-2">
    <a href="https://db-ip.com" target="_blank" rel="noopener noreferrer">IP Geolocation by DB-IP</a>
  </div>
</div>
